var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSwitch = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2.2,
  width: 24,
  height: 24,
  strokeLinecap: "round",
  strokeMiterlimit: 10
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "switch_svg__st0",
  d: "M12.2 6.6h6.2M6.4 18.4H13M6.4 12.5h12"
})));
export default SvgSwitch;